<div class="layout-container">
  <app-sidebar></app-sidebar>
  <main class="main-content">
    <app-topbar></app-topbar>
    <div class="content-area">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
